import React, { useEffect, useState } from 'react'

import { Outlet } from 'react-router'
import { useNavigate } from 'react-router-dom'
import { useQuery } from 'react-query'
import { insightsApi, logout } from '../services/api'
import * as Vlab from 'vlab-frontend-components'
import { VlabLogo } from '../assets/vlab-logo'
import { DASHBOARD, IAM_URL, MATERNITY_URL } from '../utils/constants'
import { useTranslation } from 'react-i18next'
import Translator from '../components/i18n/translator'
import { languages } from '../services/language'
import styled from 'styled-components'
import SidebarItems from './sidebar-items'
import { useExpiredTokenListener } from '../hooks/useExpiredToken';
// import mixpanel from 'mixpanel-browser'
// import RecapDialog from '../pages/home/components/Recap/RecapModal'

interface MenuItemSelected {
    [key: string]: boolean
}

interface MenuItemSelected {
    vbabyInsights: boolean
    vbabyExams: boolean
    medicalReports: boolean
    reports: boolean
    customizations: boolean
    logout: boolean
    hooksFleury: boolean
    videoReports: boolean
    mp4Reprocess: boolean
    platformVlab: boolean
    settings: boolean
    marketing: boolean
    financial: boolean
    storage: boolean
    maternityBooklet: boolean
}

const mapLanguageToCountry = (language: string): string => {
    if (language) {
        const lowerCaseLanguage = language.toLowerCase()
        if (lowerCaseLanguage.includes('pt')) return 'BR'
        if (lowerCaseLanguage.includes('en')) return 'US'
        if (lowerCaseLanguage.includes('es')) return 'ES'
        return 'US'
    } else return 'US'
}

type openProp = {
    open: boolean
}

// Partes comentadas eram usadas na para exibir a testeira da retrospectiva

// type SelectProps = {
//     label: string
//     value: string
// };

const OutletWrapper = styled.div<openProp>`
    background-color: #ffffff;
    padding: 0px 32px 0px 32px;
    margin-left: ${(props: { open: boolean }) => (props.open ? '270px' : '68px')};
    transition: margin-left 0.3s linear;
    min-height: 100vh;

    @media (max-width: 880px) {
        padding: 0 16px;
        margin-left: 0;
    }
`;

export default function WithNavigations() {
    useExpiredTokenListener();
    const navigate = useNavigate()
    const { i18n, t } = useTranslation()
    const [open, setOpen] = useState(false)
    const [isAdmin, setIsAdmin] = useState(false)
    const [hasMedicalReports, setHasMedicalReports] = useState(false)
    const [hasDicom, setHasDicom] = useState(false)
    const [hasMarketing, setHasMarketing] = useState(false)
    const [hasNotification, setHasNotification] = useState(false)
    const [hasBooklet, setHasBooklet] = useState(false);
    const [hasCustomization, setHastCustomization] = useState(false)
    const [hasFinancial, setHasFinancial] = useState(false)
    const [hasStorage, setHasStorage] = useState(false)
    const [menuSelected, setIsMenuSelected] = React.useState<MenuItemSelected>({
        vbabyInsights: true,
        vbabyExams: false,
        dicom: false,
        medicalReports: false,
        reports: false,
        customizations: false,
        logout: false,
        hooksFleury: false,
        videoReports: false,
        mp4Reprocess: false,
        platformVlab: false,
        settings: false,
        marketing: false,
        notification: false,
        financial: false,
        storage: false,
        maternityBooklet: false,
    })
    const [screenWidth, setScreenWidth] = useState(window.innerWidth)
    // const [organizations, setOrganizations] = useState<SelectProps[]>([]);
    // const [organizationUrl, setOrganizationUrl] = useState([{code: '', description: '', url:''}]);
    // const [selectedOrganizationCode, setSelectedOrganizationCode] = useState('');
    // const [selectedOrganization, setSelectedOrganization] = useState({code: '', description: '', url:''});
    // const [openRecap, setOpenRecap] = useState(false);

    const initialLanguage = languages.getLanguage()
    const [country, setCountry] = useState(() => {
        if (initialLanguage !== null) {
            return mapLanguageToCountry(initialLanguage)
        }
        return 'US'
    })

    // mixpanel.init("c56e9d183baa82de0879a7d35b32a033", {
    //     persistence: "localStorage",
    // });

    useEffect(() => {
        const handleResize = () => {
            setScreenWidth(window.innerWidth)
        }

        window.addEventListener('resize', handleResize)

        return () => {
            window.removeEventListener('resize', handleResize)
        }
    }, [])

    useEffect(() => {
        const storedLanguage = languages.getLanguage()

        if (storedLanguage) {
            setCountry(mapLanguageToCountry(storedLanguage))
            i18n.changeLanguage(storedLanguage)
            document.documentElement.lang = storedLanguage
        } else {
            if (i18n.language) {
                setCountry(mapLanguageToCountry(i18n.language))
                i18n.changeLanguage(i18n.language)
                document.documentElement.lang = i18n.language
            } else {
                setCountry(mapLanguageToCountry('en'))
                i18n.changeLanguage('en')
                document.documentElement.lang = 'en'
            }
        }

        // getUserOrganizations();
    }, [])

    // const getUserOrganizations = async () => {
    //     try {
    //       const organizations = await insightsApi.getOrganizationsRecap();
    //       setOrganizations(organizations.organizations.map((org: { code: any; description: any }) => ({ value: org.code, label: org.description })));
    //       setOrganizationUrl(organizations.organizations);  
    //       if (organizations && organizations.organizations.length > 1) {
    //         setSelectedOrganization(organizations.organizations[0]);
    //       }
    //     } catch (error) {
    //       console.log(error)
    //     }
    // }

    const changeLanguage = (country: string) => {
        let languageCode = 'en'

        switch (country) {
            case 'US':
                languageCode = 'en'
                break
            case 'ES':
                languageCode = 'es'
                break
            case 'BR':
                languageCode = 'pt-BR'
                break
            default:
                languageCode = 'en'
                break
        }

        document.documentElement.lang = languageCode
        i18n.changeLanguage(languageCode)
        languages.setLanguage(languageCode)
    }

    const getProfileData = async () => {
        const resultProfile = await insightsApi.getProfile()
        return resultProfile
    }

    const profileDataQuery = useQuery('profileData', getProfileData, {
        onError: (error: any) => {
        }
    })

    const { data: profileData } = profileDataQuery
    const isProfilePermissionsResolved = !profileDataQuery.isLoading

    useEffect(() => {
        const hasAdminPolicy = profileData?.profileInfo?.user?.is_vlab || false
        setIsAdmin(hasAdminPolicy)
        const hasDicom = profileData?.profileInfo?.user?.policies?.includes('vlab:dicom:user') || false
        setHasDicom(hasDicom)
        const hasMedicalReports = profileData?.profileInfo?.user?.policies?.includes('vlab:vmedreport:user') || false
        setHasMedicalReports(hasMedicalReports)
        const hasMarketing = profileData?.profileInfo?.user?.policies?.includes('vlab:marketing:user') || false
        setHasMarketing(hasMarketing)
        const hasNotification = profileData?.profileInfo?.user?.policies?.includes('vlab:notification:user') || profileData?.profileInfo?.user?.policies?.includes('vlab:vbaby:appuser') || false
        setHasNotification(hasNotification)
        const hasCustomization =
            profileData?.profileInfo?.user?.policies?.includes('vlab:vmedreport:user') ||
            profileData?.profileInfo?.user?.policies?.includes('vlab:vmusic:user') ||
            profileData?.profileInfo?.user?.policies?.includes('vlab:vbaby2:watch') ||
            profileData?.profileInfo?.user?.policies?.includes('vlab:admcontact:user') ||
            profileData?.profileInfo?.user?.policies?.includes('vlab:admunit:user') ||
            false
        setHastCustomization(hasCustomization)
        const hasFinancial = profileData?.profileInfo?.user?.policies?.includes('vlab:bill:user') || false
        setHasFinancial(hasFinancial)
        const hasStorage =
            profileData?.profileInfo?.user?.policies?.includes('vlab:medreport:user') ||
            profileData?.profileInfo?.user?.policies?.includes('vlab:dicom:user') ||
            false
        setHasStorage(hasStorage)
        const hasBooklet =
            profileData?.profileInfo?.user?.policies?.includes('vlab:booklet:user') ||
            profileData?.profileInfo?.user?.policies?.includes('vlab:booklet:admin') ||
            false;
        setHasBooklet(hasBooklet)
    }, [profileData])

    const hasOnlyBookletPolicy = () => {
        const policies = profileData?.profileInfo?.user?.policies
        if (!policies || policies.length === 0) return false
        const filteredPolicies = policies.filter(
            (policy: string) => policy !== 'vlab:iam:user'
        )
        if (filteredPolicies.length === 0) return false
        return filteredPolicies.every(
            (policy: string) =>
                policy === 'vlab:booklet:user' || policy === 'vlab:booklet:admin'
        )
    }

    const handleMenuItemClick = (index: number) => {
        const updatedMenuSelected: MenuItemSelected = {
            vbabyInsights: false,
            vbabyExams: false,
            dicom: false,
            medicalReports: false,
            reports: false,
            customizations: false,
            logout: false,
            hooksFleury: false,
            videoReports: false,
            mp4Reprocess: false,
            platformVlab: false,
            settings: false,
            marketing: false,
            notification: false,
            financial: false,
            storage: false,
            maternityBooklet: false,
        }

        switch (index) {
            case 0:
                updatedMenuSelected.vbabyInsights = true
                navigate('/')
                break
            case 1:
                updatedMenuSelected.vbabyExams = true
                window.location.href = `${DASHBOARD}`
                break
            case 2:
                updatedMenuSelected.dicom = true
                window.location.href = `${DASHBOARD}/#/images`
                break
            case 3:
                updatedMenuSelected.medicalReports = true
                window.location.href = `${DASHBOARD}/#/medical-reports`
                break
            case 4:
                updatedMenuSelected.reports = true
                window.location.href = `${DASHBOARD}/#/reports`
                break
            case 5:
                updatedMenuSelected.customizations = true
                window.location.href = `${DASHBOARD}/#/customization`
                break
            case 6:
                updatedMenuSelected.marketing = true
                window.location.href = `${DASHBOARD}/#/marketing`
                break
            case 7:
                updatedMenuSelected.hooksFleury = true
                window.location.href = `${DASHBOARD}/#/fleury-hooks`
                break
            case 8:
                updatedMenuSelected.mp4Reprocess = true
                window.location.href = `${DASHBOARD}/#/reprocess-mp4`
                break
            case 9:
                updatedMenuSelected.platformVlab = true
                window.location.href = IAM_URL
                break
            case 10:
                logout().finally(() => {
                    window.location.href = `${IAM_URL}/#/logout`;
                });
                return
            case 11:
                updatedMenuSelected.settings = true
                window.location.href = `${IAM_URL}/#/profile`
                break
            case 12:
                updatedMenuSelected.notification = true
                window.location.href = `${DASHBOARD}/#/communication`
                break
            case 13:
                updatedMenuSelected.financial = true
                window.location.href = `${DASHBOARD}/#/financial`
                break
            case 14:
                updatedMenuSelected.storage = true
                window.location.href = `${DASHBOARD}/#/storage`
                break
            case 15:
                updatedMenuSelected.maternityBooklet = true
                window.location.href = `${MATERNITY_URL}/#/booklet/home`
                break
        }

        setIsMenuSelected(updatedMenuSelected)
    }

    const handleMouseEnter = () => {
        setOpen(true)
    }

    const handleMouseLeave = () => {
        setOpen(false)
    }

    // const handleDownloadRecap = () => {
    //     if (!selectedOrganization) {
    //         return;
    //     }
    //     window.open(selectedOrganization.url, "_blank");

    //     const trackingData = {
    //         'distinct_id': selectedOrganization.code,
    //         'USER': profileData?.profileInfo?.user.identity,
    //     };
    //     mixpanel.track('APP_DASHBOARD_DOWNLOAD_RECAP', trackingData);
    // };
    
    // const handleOpenModal = () => {
    //     setSelectedOrganizationCode(organizations[0].value);
    //     if (organizations.length === 1) {
    //         handleDownloadRecap();
    //     }
    //     else {
    //         setOpenRecap(true);
    //     }
    // };

    return (
        <>
         {/* {organizations && organizations.length > 0 && (
            <div style={{ zIndex: 5, backgroundColor: "#011495", width: "100%", textAlign: "center", height: "50px", paddingTop: "17px", position: 'fixed', display:"flex", gap: '10px', justifyContent: "center" }}>
            <div>
                <Vlab.Typography type='poppinsBodyS' color='white'>
                🌟 <Translator path='recap.milestones'/>&nbsp; 
                <button style={{backgroundColor:"transparent", border:"none"}} onClick={handleOpenModal}>
                    <Vlab.Typography type='poppinsBodyS' color='primaryLight' style={{textDecoration: 'underline'}}><Translator path='recap.results' /></Vlab.Typography>
                </button>
                🌟
                </Vlab.Typography>
            </div>
            <RecapDialog
                open={openRecap}
                setOpen={setOpenRecap}
                object={selectedOrganizationCode}
                setObject={setSelectedOrganizationCode}
                organization={selectedOrganization}
                setOrganization={setSelectedOrganization}
                retrospective={handleDownloadRecap}
                options={organizations}
                organizations={organizationUrl}
            />
            </div>  
        )} */}
        {/* {organizations && organizations.length > 0 && (
            <div style={{ height: '50px' }}></div>
        )} */}
            {screenWidth < 880 ? (
                <Vlab.Header
                    open={open}
                    position="left"
                    style={
                        screenWidth < 880
                            ? {
                                  margin: '0',
                                  width: '100%'
                              }
                            : {}
                    }
                >
                    <Vlab.MobileMenu containerStyle={{ zIndex: '9999' }}>
                        <SidebarItems
                            isAdmin={isAdmin}
                            hasMedicalReports={hasMedicalReports}
                            hasDicom={hasDicom}
                            hasMarketing={hasMarketing}
                            hasNotification={hasNotification}
                            hasFinancial={hasFinancial}
                            hasStorage={hasStorage}
                            isProfilePermissionsResolved={isProfilePermissionsResolved}
                            hasOnlyBookletPolicy={hasOnlyBookletPolicy()}
                            menuSelected={menuSelected}
                            handleMenuItemClick={handleMenuItemClick}
                            navigateToUpsell={(feature: string) => window.location.href = `${DASHBOARD}/#/feature-upsell/${feature}`}
                            country={country}
                            setCountry={setCountry}
                            changeLanguage={changeLanguage}
                            open={true}
                        />
                    </Vlab.MobileMenu>
                </Vlab.Header>
            ) : (
                <div
                    style={{
                    marginLeft: open ? "20px" : "0",
                    transition: "margin-left 0.3s linear",
                    }}
                >
                    <Vlab.Header open={open} position="left">
                        <Vlab.HeaderItem>
                            <Vlab.Typography type="headingS6" color="white100" style={{ fontWeight: "500" }}>
                                Insights
                            </Vlab.Typography>
                        </Vlab.HeaderItem>

                        <Vlab.HeaderItem>
                            <VlabLogo />
                        </Vlab.HeaderItem>
                    </Vlab.Header>
                </div>
            )}

            <Vlab.Sidebar variant={'secondary'} open={open} position={'left'} onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave} width={270}>
                {/* {organizations && organizations.length > 0 && (
                    <div style={{ backgroundColor: "#011495", width: "100%", height: "50px" }}></div>
                )} */}
                <Vlab.MenuHeader open={open}>
                    <Vlab.MenuHeaderItem
                        avatar={<Vlab.Avatar src={''} size={24} />}
                        label={
                            <Vlab.Typography color="white100" type="subheadingS">
                                <Translator path="menu.user" />
                            </Vlab.Typography>
                        }
                        settings={<Vlab.ButtonIconSettings variant={'primary'} onClick={() => handleMenuItemClick(11)}></Vlab.ButtonIconSettings>}
                    />
                </Vlab.MenuHeader>

                <Vlab.MenuList onClick={() => null} width="270px">
                    <div className="h-[calc(100vh-200px)] overflow-y-auto !overflow-x-hidden">
                        <Vlab.MenuItem
                            open={open}
                            icon={<Vlab.LineChartIcon />}
                            label={
                                <Vlab.Typography color="greyDark" type="subheadingS">
                                    Insights
                                </Vlab.Typography>
                            }
                            onClick={() => handleMenuItemClick(0)}
                            isSelected={menuSelected.vbabyInsights}
                            width="270px"
                        />

                        <Vlab.MenuItem
                            open={open}
                            icon={<Vlab.ExamIcon />}
                            label={
                                <Vlab.Typography
                                    color="greyDark"
                                    type="subheadingS"
                                    style={
                                        isProfilePermissionsResolved && hasOnlyBookletPolicy()
                                            ? { display: 'inline-flex', alignItems: 'center' }
                                            : undefined
                                    }
                                >
                                    <Translator path="menu.examsTitle" />
                                    {isProfilePermissionsResolved && hasOnlyBookletPolicy() && (
                                        <span style={{ color: '#0166FF', marginLeft: '4px', fontSize: '12px', fontWeight: 500 }}>
                                            {t('menu.learnMore')}
                                        </span>
                                    )}
                                </Vlab.Typography>
                            }
                            onClick={() =>
                                !isProfilePermissionsResolved
                                    ? undefined
                                    : hasOnlyBookletPolicy()
                                    ? window.location.href = `${DASHBOARD}/#/feature-upsell/recordings`
                                    : handleMenuItemClick(1)
                            }
                            isSelected={menuSelected.vbabyExams}
                            width="270px"
                        />

                        <Vlab.MenuItem
                            open={open}
                            icon={<Vlab.ImageIcon />}
                            label={
                                <Vlab.Typography
                                    color="greyDark"
                                    type="subheadingS"
                                    style={
                                        isProfilePermissionsResolved && !hasDicom
                                            ? { display: 'inline-flex', alignItems: 'center' }
                                            : undefined
                                    }
                                >
                                    <Translator path="menu.dicomTitle" />
                                    {isProfilePermissionsResolved && !hasDicom && (
                                        <span style={{ color: '#0166FF', marginLeft: '4px', fontSize: '12px', fontWeight: 500 }}>
                                            {t('menu.learnMore')}
                                        </span>
                                    )}
                                </Vlab.Typography>
                            }
                            onClick={() =>
                                !isProfilePermissionsResolved
                                    ? undefined
                                    : hasDicom
                                    ? handleMenuItemClick(2)
                                    : window.location.href = `${DASHBOARD}/#/feature-upsell/images`
                            }
                            isSelected={menuSelected.dicom}
                            width="270px"
                        />

                        <Vlab.MenuItem
                            open={open}
                            icon={<Vlab.ReportIcon />}
                            label={
                                <Vlab.Typography
                                    color="greyDark"
                                    type="subheadingS"
                                    style={
                                        isProfilePermissionsResolved && !hasMedicalReports
                                            ? { display: 'inline-flex', alignItems: 'center' }
                                            : undefined
                                    }
                                >
                                    <Translator path="menu.medicalReportsTitle" />
                                    {isProfilePermissionsResolved && !hasMedicalReports && (
                                        <span style={{ color: '#0166FF', marginLeft: '4px', fontSize: '12px', fontWeight: 500 }}>
                                            {t('menu.learnMore')}
                                        </span>
                                    )}
                                </Vlab.Typography>
                            }
                            onClick={() =>
                                !isProfilePermissionsResolved
                                    ? undefined
                                    : hasMedicalReports
                                    ? handleMenuItemClick(3)
                                    : window.location.href = `${DASHBOARD}/#/feature-upsell/results`
                            }
                            isSelected={menuSelected.medicalReports}
                            width="270px"
                        />

                        {hasNotification && (
                            <Vlab.MenuItem
                                open={open}
                                icon={<Vlab.BellIcon height={18} width={16} />}
                                label={
                                    <Vlab.Typography color="greyDark" type="subheadingS">
                                        <Translator path="menu.communicationTitle" />
                                    </Vlab.Typography>
                                }
                                onClick={() => handleMenuItemClick(12)}
                                isSelected={menuSelected.communication}
                                width="270px"
                            />
                        )}

                        {hasBooklet && (
                            <Vlab.MenuItem
                                open={open}
                                icon={<Vlab.BookletIcon />}
                                label={
                                    <Vlab.Typography color="greyDark" type="subheadingS">
                                    <Translator path="menu.maternityBookletTitle" />
                                    </Vlab.Typography>
                                }
                                    onClick={() => handleMenuItemClick(15)}
                                    isSelected={menuSelected.maternityBooklet}
                                    width="270px"
                            />
                        )}

                        {hasMarketing && (
                            <Vlab.MenuItem
                                open={open}
                                icon={<Vlab.MarketingIcon />}
                                label={
                                    <Vlab.Typography color="greyDark" type="subheadingS">
                                        <Translator path="menu.marketingTitle" />
                                    </Vlab.Typography>
                                }
                                onClick={() => handleMenuItemClick(6)}
                                isSelected={menuSelected.marketing}
                                width="270px"
                            />
                        )}

                        {hasStorage && (
                            <Vlab.MenuItem
                                open={open}
                                icon={<Vlab.CloudContainedIcon />}
                                label={
                                    <Vlab.Typography color="greyDark" type="subheadingS">
                                        <Translator path="menu.storageTitle" />
                                    </Vlab.Typography>
                                }
                                onClick={() => handleMenuItemClick(14)}
                                isSelected={menuSelected.storage}
                                width="270px"
                            />
                        )}

                        {hasCustomization && (
                            <Vlab.MenuItem
                                open={open}
                                icon={<Vlab.PencilIcon />}
                                label={
                                    <Vlab.Typography color="greyDark" type="subheadingS">
                                        <Translator path="menu.customizationTitle" />
                                    </Vlab.Typography>
                                }
                                onClick={() => handleMenuItemClick(5)}
                                isSelected={menuSelected.customizations}
                                width="270px"
                            />
                        )}

                        {hasFinancial && (
                            <Vlab.MenuItem
                                open={open}
                                icon={<Vlab.MoneyIcon width={16} height={18} />}
                                label={
                                    <Vlab.Typography color="greyDark" type="subheadingS">
                                        <Translator path="menu.financialTitle" />
                                    </Vlab.Typography>
                                }
                                onClick={() => handleMenuItemClick(13)}
                                isSelected={menuSelected.financial}
                                width="270px"
                            />
                        )}

                        <Vlab.MenuItem
                            open={open}
                            icon={<Vlab.ChartIcon />}
                            label={
                                <Vlab.Typography
                                    color="greyDark"
                                    type="subheadingS"
                                    style={
                                        isProfilePermissionsResolved && hasOnlyBookletPolicy()
                                            ? { display: 'inline-flex', alignItems: 'center' }
                                            : undefined
                                    }
                                >
                                    <Translator path="menu.reportsTitle" />
                                    {isProfilePermissionsResolved && hasOnlyBookletPolicy() && (
                                        <span style={{ color: '#0166FF', marginLeft: '4px', fontSize: '12px', fontWeight: 500 }}>
                                            {t('menu.learnMore')}
                                        </span>
                                    )}
                                </Vlab.Typography>
                            }
                            onClick={() =>
                                !isProfilePermissionsResolved
                                    ? undefined
                                    : hasOnlyBookletPolicy()
                                    ? window.location.href = `${DASHBOARD}/#/feature-upsell/reports`
                                    : handleMenuItemClick(4)
                            }
                            isSelected={menuSelected.videoReports}
                            divider={true}
                            width="270px"
                        />

                        {isAdmin && (
                            <Vlab.MenuItem
                                open={open}
                                icon={<Vlab.HookIcon />}
                                label={
                                    <Vlab.Typography color="greyDark" type="subheadingS">
                                        <Translator path="menu.hooksFleuryTitle" />
                                    </Vlab.Typography>
                                }
                                adminColor="rgb(245, 0, 87)"
                                onClick={() => handleMenuItemClick(7)}
                                isSelected={menuSelected.hooksFleury}
                                width="270px"
                            />
                        )}

                        {isAdmin && (
                            <Vlab.MenuItem
                                open={open}
                                icon={<Vlab.ReprocessIcon />}
                                label={
                                    <Vlab.Typography color="greyDark" type="subheadingS">
                                        <Translator path="menu.mp4ReprocessTitle" />
                                    </Vlab.Typography>
                                }
                                adminColor="rgb(245, 0, 87)"
                                onClick={() => handleMenuItemClick(8)}
                                isSelected={menuSelected.mp4Reprocess}
                                divider={true}
                                width="270px"
                            />
                        )}

                        <Vlab.MenuItem
                            open={open}
                            icon={<Vlab.GooutIcon />}
                            label={
                                <Vlab.Typography color="greyDark" type="subheadingS">
                                    <Translator path="menu.goOutTitle" />
                                </Vlab.Typography>
                            }
                            onClick={() => handleMenuItemClick(10)}
                            isSelected={menuSelected.logout}
                            divider={true}
                            width="270px"
                        />
                    </div>
                </Vlab.MenuList>

                <Vlab.MenuFooter open={open}>
                    {open ? (
                        <>
                            <div
                                style={{
                                    width: '100%',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    marginBottom: '24px'
                                }}
                            >
                                <div
                                    style={{
                                        width: 'calc(100% - 24px)',
                                        padding: '4px 0'
                                    }}
                                >
                                    <Vlab.FlagSelect
                                        selected={country.toUpperCase()}
                                        onSelect={(selectedCountry: any) => {
                                            setCountry(selectedCountry)
                                            changeLanguage(selectedCountry)
                                        }}
                                        countries={['US', 'ES', 'BR']}
                                        maxHeight="200px"
                                    />
                                </div>
                            </div>
                            <Vlab.MenuFooterItem button={<Vlab.PlatformButton variant="secondary" name={t('menu.platform')} onClick={() => handleMenuItemClick(9)} />} />
                        </>
                    ) : (
                        <Vlab.MenuFooterItem button={<Vlab.ButtonV variant="secondary" onClick={() => handleMenuItemClick(0)}></Vlab.ButtonV>} />
                    )}
                </Vlab.MenuFooter>
            </Vlab.Sidebar>

            <OutletWrapper open={open}>
                <Outlet />
            </OutletWrapper>
        </>
    )
}
